import H from '@here/maps-api-for-javascript';
import { tourColors, colors } from 'global/variables';
import { divideColors } from 'utils/map/MapUtils';

const { unselectedTourColor, unusedMarkerStroke, routeGradientStart, routeGradientEnd } = colors;

export const buildLineStringFromCoords = (coordinates) => {
  const lineString = new H.geo.LineString();
  coordinates.forEach(([lng, lat]) => {
    lineString.pushLatLngAlt(lat, lng, 0);
  });
  return lineString;
};

export const getPolylineStyle = (feature, gradientRoutes, fleetType, showOverlaps) => {
  const { routeId, mode, isStopsRequest, fromStop, totalStops, isUndesiredLine, colorGradient } =
    feature.properties;
  const vehicleType = mode || fleetType;
  const isPedestrian = vehicleType === 'pedestrian';
  const color =
    isUndesiredLine && showOverlaps
      ? colorGradient
      : tourColors[routeId % tourColors.length].delivery.inner;
  const gradientColor = divideColors(routeGradientStart, routeGradientEnd, fromStop, totalStops);
  const strokeColor = gradientRoutes && isStopsRequest ? gradientColor : color;
  return {
    strokeColor,
    lineWidth: 2,
    lineDash: isPedestrian ? [2, 2] : [],
  };
};

export const getUnselectedPolylineStyle = () => ({
  strokeColor: unselectedTourColor,
  lineWidth: 1.5,
});

export const getHitAreaPolylineStyle = () => ({
  strokeColor: 'rgba(0, 0, 0, 0)',
  lineWidth: 20,
});

export const getOriginalLocationPolylineStyle = () => ({
  strokeColor: unusedMarkerStroke,
  lineWidth: 2,
  lineDash: [3, 2],
});

export const createTourPolyline = (feature, style) => {
  const lineString = buildLineStringFromCoords(feature.geometry.coordinates);
  return new H.map.Polyline(lineString, { style, data: feature });
};
